/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon32Regular = forwardRef('WeatherThermometerIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 18.126A4.002 4.002 0 0 0 16 26a4 4 0 0 0 1-7.874V10.5a1 1 0 1 0-2 0v7.626ZM16 20a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 7a6 6 0 0 1 12 0v8.292a9 9 0 1 1-12 0V7Zm6-4a4 4 0 0 0-4 4v8.755a1 1 0 0 1-.374.78 7 7 0 1 0 8.749 0 1 1 0 0 1-.375-.78V7a4 4 0 0 0-4-4Z" })));
});
